import { render } from "./index.vue?vue&type=template&id=be103806&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=be103806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be103806"]])

export default __exports__